import { render, staticRenderFns } from "./shipping-queue.vue?vue&type=template&id=31d9358d&scoped=true&"
import script from "./js/shipping-queue.js?vue&type=script&lang=js&"
export * from "./js/shipping-queue.js?vue&type=script&lang=js&"
import style0 from "./shipping-queue.vue?vue&type=style&index=0&id=31d9358d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31d9358d",
  null
  
)

export default component.exports